import { useNavigate } from 'react-router-dom';

import styles from './NotFoundPage.module.scss';

import error404 from '@/assets/img/error404.jpg';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Modal } from '@/shared/ui-kit/Modal/Modal';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <title>Страница не найдена — Order2Go.ru</title>
      <Modal closable={false} hideHeader open onClose={() => navigate('/')}>
        <div className={styles.container}>
          <h2 className={styles.title}>Не нашли такую страницу</h2>
          <div className={styles.imageContainer}>
            <img src={error404} alt="" />
            <div className={styles.textContainer}>
              <p className={styles.text}>Этот пункт меню исчез…</p>
              <p className={styles.textSub}>Но у нас есть много других</p>
            </div>
          </div>
          <Button className={styles.button} onClick={() => navigate('/')}>
            На главную
          </Button>
        </div>
      </Modal>
    </>
  );
}
